"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var schema_1 = require("./schema");
var normalize_1 = require("./normalize");
var parse_1 = require("../libs/parse");
// a root type of editor
var Doc = /** @class */ (function (_super) {
    __extends(Doc, _super);
    function Doc() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'doc';
        _this.content = 'block+';
        return _this;
    }
    return Doc;
}(schema_1.SylSchema));
exports.Doc = Doc;
var Paragraph = /** @class */ (function (_super) {
    __extends(Paragraph, _super);
    function Paragraph() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'paragraph';
        _this.group = 'block';
        _this.content = 'inline*';
        _this.tagName = function () { return 'p'; };
        _this.attrs = {
            align: {
                default: 'left'
            },
            class: {
                default: ''
            },
            lineIndent: {
                default: ''
            },
            spaceBefore: {
                default: ''
            },
            spaceAfter: {
                default: ''
            },
            spaceBoth: {
                default: ''
            },
            lineHeight: {
                default: ''
            }
        };
        _this.defining = false;
        _this.parseDOM = [
            {
                tag: 'p',
                defaultFontSize: 16,
                priority: 20,
                canMatch: function (dom) { return true; },
                formatAttrs: function (v, dom) { return v; },
                getAttrs: function (dom) {
                    if (!this.canMatch(dom))
                        return false;
                    var style = dom.getAttribute('style') || '';
                    return this.formatAttrs(__assign(__assign({}, parse_1.parseTypesetStyle(style, undefined, this.defaultFontSize)), { class: dom.className }), dom);
                }
            }
        ];
        _this.toDOM = function (node) {
            var attrs = {};
            var style = parse_1.getTypesetDOMStyle(node.attrs, _this.attrs);
            if (style)
                attrs.style = style;
            if (node.attrs.class)
                attrs.class = node.attrs.class;
            return ['p', attrs, 0];
        };
        return _this;
    }
    return Paragraph;
}(schema_1.Formattable));
exports.Paragraph = Paragraph;
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'text';
        _this.group = 'inline';
        return _this;
    }
    return Text;
}(schema_1.SylSchema));
exports.Text = Text;
var Break = /** @class */ (function (_super) {
    __extends(Break, _super);
    function Break() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'inline';
        _this.inline = true;
        _this.name = 'break';
        _this.selectable = false;
        _this.content = undefined;
        _this.parseDOM = [{ tag: 'br' }];
        _this.toDOM = function () {
            return ['br'];
        };
        return _this;
    }
    return Break;
}(schema_1.Formattable));
exports.Break = Break;
var basicSchema = normalize_1.updateSchema({
    nodes: {},
    marks: {}
}, [
    new schema_1.SchemaMeta(schema_1.FORMAT_TYPE.BLOCK, 'doc', new Doc()),
    new schema_1.SchemaMeta(schema_1.FORMAT_TYPE.BLOCK, 'paragraph', new Paragraph()),
    new schema_1.SchemaMeta(schema_1.FORMAT_TYPE.BLOCK, 'text', new Text()),
    new schema_1.SchemaMeta(schema_1.FORMAT_TYPE.BLOCK, 'break', new Break())
]);
exports.basicSchema = basicSchema;
//# sourceMappingURL=basics.js.map